//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
//#endregion
//#region Components
import { Navigate, Route, Routes } from "react-router-dom";
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import Preloader from "components/Preloader/Preloader";
import RegisterSpaceForm from "./components/RegisterSpaceForm/RegisterSpaceForm";
import CampusListContentView from "./components/CampusListContentView";
import SpaceListByCampusView from "./components/SpaceListByCampusView/SpaceListByCampusView";
import ToastMessage from "components/ToastMessage/ToastMessage";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import useDataRelatedToSpaceAdmin from "./utils/hooks/useDataRelatedToSpaceAdmin";
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
import useToastMessage from "components/ToastMessage/utils/hooks/useToastMessage";
import useDashboardContext from "routes/utils/context/useDashboardContext";
//#endregion

const SettingsSpaceAdmin = () => {
    //#region Custom Hooks
    const loadingRequest = useLoadingRequest();
    const toastMessage = useToastMessage();
    const { user } = useDashboardContext();
    const dataRelatedToSpaceAdmin = useDataRelatedToSpaceAdmin({
        loadingRequest, userRole: user.role.id
    });
    const [spaceHasBeenDeleted, setSpaceHasBeenDeleted] = useState(false);
    //#endregion
    return (
        <>
            <HelmetUTP title="Admin. de espacios" />
            <ToastMessage {...toastMessage.value} />
            <Preloader {...loadingRequest.value} />
            <Routes>
                <Route
                    path="campus"
                    element={
                        <CampusListContentView data={dataRelatedToSpaceAdmin} />} />
                <Route
                    path="campus-espacios"
                    element={
                        <SpaceListByCampusView
                            loadingRequest={loadingRequest}
                            spaceTypeList={dataRelatedToSpaceAdmin.spaceTypeList} />} />
                <Route
                    path="registrar"
                    element={
                        <RegisterSpaceForm
                            data={dataRelatedToSpaceAdmin}
                            toastMessage={toastMessage}
                            loadingRequest={loadingRequest} />} />
                <Route
                    path="editar"
                    element={
                        <RegisterSpaceForm
                            isUpdate
                            toastMessage={toastMessage}
                            data={dataRelatedToSpaceAdmin}
                            loadingRequest={loadingRequest}
                            spaceHasBeenDeleted={{
                                value: spaceHasBeenDeleted,
                                set: setSpaceHasBeenDeleted
                            }} />} />
                <Route
                    path="*"
                    element={<Navigate to={ABSOLUTE_PATHS.SETTINGS} replace />} />
            </Routes>
        </>
    );
}

export default SettingsSpaceAdmin;